import { useFontStore } from "../stores/font-store";

/**
 * Hook to access font state and actions
 * Use this in components that need to display or select fonts
 */
export function useFonts() {
	const fonts = useFontStore((state) => state.fonts);
	const isLoading = useFontStore((state) => state.isLoading);
	const error = useFontStore((state) => state.error);
	const fetchFonts = useFontStore((state) => state.fetchFonts);
	const getWeightsForFont = useFontStore((state) => state.getWeightsForFont);
	const getHeadingFontOptions = useFontStore((state) => state.getHeadingFontOptions);
	const getBodyFontOptions = useFontStore((state) => state.getBodyFontOptions);

	return {
		fonts,
		isLoading,
		error,
		fetchFonts,
		getWeightsForFont,
		getHeadingFontOptions,
		getBodyFontOptions,
	};
}
